import { REMOVE_CALLABLE_ASSOCIATION } from '../constants/MethodNames';
import { callingAPIMethodWithQueue } from '../utils/hsCallingUtils';
export default function RemoveCallableAssociation(callableAssociation) {
  return callingAPIMethodWithQueue(REMOVE_CALLABLE_ASSOCIATION, callableAssociation);
}